webpackJsonp([1,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(27);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.Icon = Icon;
	exports.IconStack = IconStack;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function Icon(_ref) {
	  var name = _ref.name,
	      title = _ref.title;
	
	  var hasTitle = typeof title !== 'undefined';
	
	  var icon = _react2.default.createElement('i', { className: 'fa fa-' + name, title: title, 'aria-hidden': true });
	
	  if (title) {
	    return _react2.default.createElement(
	      'span',
	      null,
	      icon,
	      _react2.default.createElement(
	        'span',
	        { className: 'sr-only' },
	        title
	      )
	    );
	  }
	
	  return icon;
	}
	
	Icon.propTypes = {
	  name: _propTypes2.default.string.isRequired,
	  title: _propTypes2.default.string
	};
	
	function IconStack(_ref2) {
	  var icons = _ref2.icons,
	      title = _ref2.title,
	      other = _objectWithoutProperties(_ref2, ['icons', 'title']);
	
	  var hasTitle = typeof title !== 'undefined';
	
	  var icon = Object.keys(icons).map(function (k, idx) {
	    var _icons$k = icons[k],
	        name = _icons$k.name,
	        className = _icons$k.className,
	        inverse = _icons$k.inverse,
	        style = _icons$k.style;
	
	    return _react2.default.createElement('i', { key: idx,
	      className: 'fa fa-' + name + ' icon-stack-icon' + (inverse ? ' fa-inverse' : '') + ' ' + (className ? className : ''),
	      style: style,
	      'aria-hidden': true
	    });
	  });
	
	  return _react2.default.createElement(
	    'span',
	    _extends({ className: 'icon-stack', title: title }, other),
	    icon,
	    hasTitle ? _react2.default.createElement(
	      'span',
	      { className: 'sr-only' },
	      title
	    ) : null
	  );
	}
	
	IconStack.propTypes = {
	  icons: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    name: _propTypes2.default.string.isRequired,
	    className: _propTypes2.default.string,
	    inverse: _propTypes2.default.boolean,
	    style: _propTypes2.default.object
	  })).isRequired,
	  title: _propTypes2.default.string
	};
	
	exports.default = Icon;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.tryParseException = tryParseException;
	exports.default = compile;
	
	var _acorn = __webpack_require__(5);
	
	var _Musika = __webpack_require__(35);
	
	var Musika = _interopRequireWildcard(_Musika);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function tryParseStack(stack) {
	  try {
	    var _stack$split$1$split$ = stack.split('\n')[1].split('), ')[1].slice(0, -1).split(':'),
	        _stack$split$1$split$2 = _slicedToArray(_stack$split$1$split$, 3),
	        fileName = _stack$split$1$split$2[0],
	        lineNumber = _stack$split$1$split$2[1],
	        columnNumber = _stack$split$1$split$2[2];
	
	    var row = parseInt(lineNumber) - 3;
	    var column = parseInt(columnNumber);
	
	    return { fileName: fileName, row: row, column: column };
	  } catch (e) {
	    return {};
	  }
	}
	
	function tryParseException(e) {
	  var message = e.message,
	      name = e.name,
	      stack = e.stack;
	
	  var _tryParseStack = tryParseStack(stack),
	      fileName = _tryParseStack.fileName,
	      row = _tryParseStack.row,
	      column = _tryParseStack.column;
	
	  if (e.fileName) fileName = e.fileName;
	  if (e.lineNumber) row = e.lineNumber - 3;
	  if (e.columnNumber) column = e.columnNumber - 1;
	
	  return { name: name, message: message, fileName: fileName, row: row, column: column, e: e };
	}
	
	function parseAcornException(e, source) {
	  var message = e.message,
	      name = e.name,
	      _e$loc = e.loc,
	      line = _e$loc.line,
	      column = _e$loc.column;
	
	  return { name: name, message: message, fileName: undefined, row: line - 1, column: column, e: e };
	}
	
	function compile(source, sampleRate) {
	  // Check for syntax errors - JavaScript doesn't provide error location otherwise
	  var fnString = '(Musika, sampleRate, setLength) => {' + source + '\n}';
	  try {
	    (0, _acorn.parse)(fnString);
	  } catch (e) {
	    return { error: parseAcornException(e, fnString) };
	  }
	
	  // Compile fn builder
	  var builder = void 0;
	  try {
	    builder = new Function('Musika', 'sampleRate', 'console', 'setLength', source);
	  } catch (e) {
	    return { error: tryParseException(e) };
	  }
	
	  // Run fn builder
	  var length = void 0,
	      fn = void 0;
	  try {
	    fn = builder(Musika, sampleRate, console, function (l) {
	      return length = l;
	    });
	  } catch (e) {
	    return { error: tryParseException(e) };
	  }
	
	  // Run fn dummy with t=0, t=length/2, t=length to check for basic errors
	  try {
	    fn(0);
	    if (length) {
	      fn(length / 2);
	      fn(length);
	    } else {
	      fn(10); // Unknown length, try 10 just in case
	    }
	  } catch (e) {
	    return { error: tryParseException(e) };
	  }
	
	  return { builder: builder, length: length, fn: fn };
	}

/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.toMinSecs = toMinSecs;
	// Pretty-print seconds as MM:SS
	function toMinSecs(secs) {
	    var mins = Math.floor(secs / 60);
	    secs = Math.floor(secs % 60);
	
	    return '' + (mins < 10 ? '0' : '') + mins + ':' + (secs < 10 ? '0' : '') + secs;
	}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Biquad = undefined;
	
	var _Biquad = __webpack_require__(30);
	
	var _Biquad2 = _interopRequireDefault(_Biquad);
	
	var _index = __webpack_require__(7);
	
	var myself = _interopRequireWildcard(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Biquad = _Biquad2.default;
	exports.default = myself;

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports) {

	module.exports = "const { Generator, Envelope, Filter, Operator, Music, Util } = Musika\n\n\n/* CONFIG */\n\n// Song\n\nconst SONG_TEMPO = Music.Tempo(4, 4, 80)\nconst SONG_BARS = 36\nconst SONG_IN_LENGTH = 0.5\nconst SONG_OUT_LENGTH = 0.5\nconst SONG_STRUCTURE = [\n  {\n    melodyKey: 'E',\n    bassNote: 'E2',\n  },\n  {\n    melodyKey: 'C',\n    bassNote: 'C2',\n  },\n]\nconst SONG_BARS_REPEAT = 4\n\nconst MELODY_NOTE_VALUE = 8\nconst MELODY_NOTE_LENGTH = SONG_TEMPO.noteLength(MELODY_NOTE_VALUE)\nconst MELODY_ACCENT = [1, 5]\nconst MELODY_NON_ACCENT_ATTENUATION = 0.5\nconst MELODY_PANNED_AMPLITUDE = 0.7\nconst MELODY_SCALE = Music.scale.pentatonic.minor\nconst MELODY_OCTAVES = [3, 4]\nconst MELODY_CHANGE_CHANCE = 0.8\nconst MELODY_PLAY_CHANCE = 0.7\n\nconst BASS_NOTE_VALUE = 2\nconst BASS_NOTE_LENGTH = SONG_TEMPO.noteLength(BASS_NOTE_VALUE)\n\nconst DRUM_NOTE_VALUE = 8\nconst DRUM_NOTE_LENGTH = SONG_TEMPO.noteLength(DRUM_NOTE_VALUE)\nconst DRUM_PLAYS_IN = [1, 5, 6]\n\nconst SNARE_NOTE_VALUE = 8\nconst SNARE_NOTE_LENGTH = SONG_TEMPO.noteLength(SNARE_NOTE_VALUE)\nconst SNARE_PLAYS_IN = [3, 7]\n\n// Instruments\n\nconst MELODY_VIBRATO_DEPTH = 0.5\nconst MELODY_VIBRATO_RATE = 4  // Cycles per note\n\nconst DRUM_FREQUENCY = 78\nconst DRUM_AMPLITUDE = 0.7\nconst DRUM_ATTACK = 0.01\nconst DRUM_ENVELOPE = [[0, 0], [DRUM_ATTACK, DRUM_FREQUENCY], [DRUM_NOTE_LENGTH, 0]]\n\nconst SNARE_AMPLITUDE = 0.2\nconst SNARE_DECAY_POWER = 7\n\n\n/* INSTRUMENTS */\n\nconst MelodyInstrument = () => {\n  const osc = Generator.Sin()\n  const vibratoOsc = Generator.Sin()\n\n  return (semitone, t) => {\n    const vibrato = vibratoOsc(MELODY_VIBRATO_RATE/MELODY_NOTE_LENGTH, t) * MELODY_VIBRATO_DEPTH\n\n    return osc(Music.semitoneToFrequency(semitone + vibrato), t)\n      * Envelope.invAttack(MELODY_NOTE_LENGTH/4, t)\n      * Envelope.release(MELODY_NOTE_LENGTH, MELODY_NOTE_LENGTH, t)\n  }\n}\n\nconst BassInstrument = () => {\n  const osc = Generator.Sin()\n\n  return (semitone, t) => osc(Music.semitoneToFrequency(semitone), t)\n    * Envelope.invAttack(BASS_NOTE_LENGTH, t)\n    * Envelope.release(BASS_NOTE_LENGTH, BASS_NOTE_LENGTH, t)\n}\n\nconst DrumInstrument = () => {\n  const bodyOsc = Generator.Sin()\n  const popOsc = Generator.Sin()\n\n  return t => {\n    const body = 0.67 * bodyOsc(Envelope.linear(DRUM_ENVELOPE, t), t)\n    const pop = 0.33 * popOsc(150 * Envelope.release(DRUM_NOTE_LENGTH - 0.0000001, DRUM_NOTE_LENGTH, t), t)\n\n    return (body + pop) * DRUM_AMPLITUDE\n      * Envelope.attack(DRUM_ATTACK, t)\n      * Envelope.release(DRUM_NOTE_LENGTH - DRUM_ATTACK, DRUM_NOTE_LENGTH, t)\n  }\n}\n\nconst snareInstrument = (t) =>\n  Generator.random() * SNARE_AMPLITUDE\n    * Envelope.release(SNARE_NOTE_LENGTH, SNARE_NOTE_LENGTH, SNARE_DECAY_POWER, t)\n\n\n/* SONG */\n\nconst SONG_LENGTH = SONG_IN_LENGTH + SONG_BARS * SONG_TEMPO.barLength + SONG_OUT_LENGTH\nsetLength(SONG_LENGTH)\n\nlet lastSongStructureIndex\nlet lastMelodyIndex\nlet melodyPlays\nlet melodySemitones\nlet chosenSemitone\nlet left = Math.random() < 0.5\n\nconst melodyInstrument = MelodyInstrument()\nconst bassInstrument = BassInstrument()\nconst drumInstrument = DrumInstrument()\n\nreturn t => {\n  if (t < SONG_IN_LENGTH) return [0, 0]\n  if (t > (SONG_LENGTH - SONG_OUT_LENGTH)) return [0, 0]\n\n  t = t - SONG_IN_LENGTH\n\n  // Song\n\n  const songStructureIndex = Math.floor((SONG_TEMPO.currentBar(t) - 1) / SONG_BARS_REPEAT)\n  const { melodyKey, bassNote } = SONG_STRUCTURE[songStructureIndex % SONG_STRUCTURE.length]\n  if (songStructureIndex !== lastSongStructureIndex) {\n    melodySemitones = MELODY_OCTAVES.flatMap(o => Music.extend(`${melodyKey}${o}`, MELODY_SCALE))\n    lastSongStructureIndex = songStructureIndex\n  }\n\n  // Melody\n\n  const currentMelodyIndex = SONG_TEMPO.currentNoteInBar(MELODY_NOTE_VALUE, t)\n  if (lastMelodyIndex !== currentMelodyIndex) {\n    if (!chosenSemitone || Math.random() < MELODY_CHANGE_CHANCE) {\n      chosenSemitone = Util.choose(melodySemitones)\n      left = !left;\n    }\n\n    melodyPlays = Math.random() < MELODY_PLAY_CHANCE\n\n    lastMelodyIndex = currentMelodyIndex\n  }\n\n  let melody = [0, 0]\n\n  if (melodyPlays) {\n    const mono = melodyInstrument(\n      chosenSemitone,\n      SONG_TEMPO.timeInNote(MELODY_NOTE_VALUE, t)\n    )\n    const a = !SONG_TEMPO.isInBar(MELODY_ACCENT, MELODY_NOTE_VALUE, t)\n      ? MELODY_NON_ACCENT_ATTENUATION\n      : 1\n    const panning = left ? -MELODY_PANNED_AMPLITUDE : MELODY_PANNED_AMPLITUDE\n\n    melody = Operator.panner(mono * a, panning)\n  }\n\n  //\n\n  const bass = bassInstrument(\n    Music.noteNameToSemitone[bassNote],\n    SONG_TEMPO.timeInNote(BASS_NOTE_VALUE, t)\n  )\n\n  const drum = SONG_TEMPO.isInBar(DRUM_PLAYS_IN, DRUM_NOTE_VALUE, t)\n    ? drumInstrument(SONG_TEMPO.timeInNote(DRUM_NOTE_VALUE, t))\n    : 0\n\n  const snare = SONG_TEMPO.isInBar(SNARE_PLAYS_IN, SNARE_NOTE_VALUE, t)\n    ? snareInstrument(SONG_TEMPO.timeInNote(SNARE_NOTE_VALUE, t))\n    : 0\n\n  return melody.map(c => Operator.mixN(c, bass, drum, snare))\n}\n"

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Player = __webpack_require__(24);
	
	var _Player2 = _interopRequireDefault(_Player);
	
	var _CPULoad = __webpack_require__(22);
	
	var _CPULoad2 = _interopRequireDefault(_CPULoad);
	
	var _Editor = __webpack_require__(23);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	var _BottomBar = __webpack_require__(21);
	
	var _BottomBar2 = _interopRequireDefault(_BottomBar);
	
	var _compile3 = __webpack_require__(4);
	
	var _compile4 = _interopRequireDefault(_compile3);
	
	var _PCM = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_SCRIPT = __webpack_require__(17);
	
	// HACK: Setting it as App.XXX_INTERVAL yields undefined inside component!?
	var BACKUP_INTERVAL = 1000;
	var DIRTY_INTERVAL = 100;
	
	var App = function (_React$Component) {
	  _inherits(App, _React$Component);
	
	  function App(props) {
	    _classCallCheck(this, App);
	
	    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));
	
	    _this.state = {
	      fn: undefined,
	      length: 0,
	      renderTime: undefined,
	      isClean: false
	    };
	
	    _this.audioCtx = new (window.AudioContext || window.webkitAudioContext)();
	    return _this;
	  }
	
	  _createClass(App, [{
	    key: 'closePanels',
	    value: function closePanels() {
	      this.refs.bottomBar.closePanels();
	    }
	
	    /* Lifecycle */
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (history.state) {
	        this.refs.editor.setSerialState(history.state);
	      }
	
	      // Mark state as never clean (always asks for confirmation)
	      this.refs.editor.markDirty();
	
	      this.backupInterval = setInterval(this.handleBackup.bind(this), BACKUP_INTERVAL);
	      this.dirtyInterval = setInterval(this.handleDirtyInterval.bind(this), DIRTY_INTERVAL);
	
	      this.handleUpdate(); // Throws
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.audioCtx.close();
	      clearInterval(this.backupInterval);
	      clearInterval(this.dirtyInterval);
	    }
	
	    /* Autosave */
	
	  }, {
	    key: 'handleBackup',
	    value: function handleBackup() {
	      var serialState = this.refs.editor.getSerialState();
	      var source = serialState.source,
	          _serialState$cursor = serialState.cursor,
	          row = _serialState$cursor.row,
	          column = _serialState$cursor.column;
	
	
	      if (!history.state || history.state.source !== source || !history.state.cursor || history.state.cursor.row !== row || history.state.cursor.column !== column) {
	        history.replaceState(serialState, '');
	      }
	    }
	
	    /* Track document changes */
	
	  }, {
	    key: 'markClean',
	    value: function markClean() {
	      this.refs.editor.markClean();
	      this.setState({ isClean: true });
	    }
	
	    // HACK! This shouldn't be polled, but there seems to be no event emitted
	    //       after dirtyCounter changes
	
	  }, {
	    key: 'handleDirtyInterval',
	    value: function handleDirtyInterval() {
	      this.setState({ isClean: this.refs.editor.isClean() });
	    }
	
	    /* Events */
	
	  }, {
	    key: 'handleKeyDown',
	    value: function handleKeyDown(e) {
	      var ctrlKey = e.ctrlKey,
	          shiftKey = e.shiftKey,
	          altKey = e.altKey,
	          keyCode = e.keyCode;
	
	      // Prevent CTRL-S from opening the webpage save dialog
	
	      if (ctrlKey && !shiftKey && !altKey && keyCode === 83 /* S */) {
	          e.preventDefault();
	        }
	        // Escape closes panels
	      else if (!ctrlKey && !shiftKey && !altKey && keyCode === 27 /* Escape */) {
	            this.closePanels();
	          }
	    }
	  }, {
	    key: 'handleKeyUp',
	    value: function handleKeyUp(_ref) {
	      var ctrlKey = _ref.ctrlKey,
	          shiftKey = _ref.shiftKey,
	          altKey = _ref.altKey,
	          keyCode = _ref.keyCode;
	
	      if (ctrlKey && !shiftKey && !altKey) {
	        if (keyCode === 83 /* S */) {
	            this.handleUpdate();
	          } else if (keyCode === 32 /* SPACE */) {
	            this.refs.player.togglePlay();
	          }
	      }
	    }
	  }, {
	    key: 'handleMouseDown',
	    value: function handleMouseDown(_ref2) {
	      var target = _ref2.target,
	          button = _ref2.button;
	
	      if (button !== 0 /* LEFT BUTTON*/) return;
	
	      for (var node = target; node; node = node.parentNode) {
	        if (node.className === 'panel') return;
	      }
	
	      this.closePanels();
	    }
	
	    /* Player events */
	
	  }, {
	    key: 'handlePlayingChange',
	    value: function handlePlayingChange(playing) {
	      this.setState({ renderTime: undefined });
	    }
	  }, {
	    key: 'handleRenderTime',
	    value: function handleRenderTime(renderTime) {
	      this.setState({ renderTime: renderTime });
	    }
	  }, {
	    key: 'handleError',
	    value: function handleError(error) {
	      try {
	        this.refs.editor.maybeAddError(error);
	      } catch (e) {/* IGNORE EXCEPTION! Let the player try to recover */}
	    }
	
	    /* Bottom bar events */
	
	  }, {
	    key: 'handleUpdate',
	    value: function handleUpdate() {
	      // Throws
	      var editor = this.refs.editor.editor;
	      var source = editor.getValue();
	
	      this.handleBackup();
	
	      var _compile = (0, _compile4.default)(source, this.audioCtx.sampleRate),
	          fn = _compile.fn,
	          length = _compile.length,
	          error = _compile.error;
	
	      this.refs.editor.maybeAddError(error); // Throws
	      this.setState({ fn: fn, length: length });
	    }
	  }, {
	    key: 'handleNew',
	    value: function handleNew(source) {
	      // Throws
	      this.setState({ fn: undefined, length: undefined });
	      this.refs.editor.new(source);
	      this.markClean();
	      this.handleUpdate(); // Throws
	    }
	  }, {
	    key: 'handleSave',
	    value: function handleSave() {
	      var script = this.refs.editor.editor.getValue();
	      var blob = new Blob([script], { type: 'application/javascript;charset=utf-8' });
	      var url = URL.createObjectURL(blob);
	
	      var link = document.createElement('a');
	      link.download = 'script.musika';
	      link.href = url;
	      link.click();
	
	      URL.revokeObjectURL(url);
	
	      this.markClean();
	    }
	  }, {
	    key: 'handleRender',
	    value: function handleRender(sampleRate) {
	      // Throws
	      this.refs.player.pause();
	
	      this.handleUpdate(); // Throws
	
	      var source = this.refs.editor.editor.getValue();
	
	      var _compile2 = (0, _compile4.default)(source, sampleRate),
	          fn = _compile2.fn,
	          length = _compile2.length,
	          compileError = _compile2.error;
	
	      this.refs.editor.maybeAddError(compileError); // Throws
	
	      var _Int16Stereo = (0, _PCM.Int16Stereo)(sampleRate, length, fn),
	          buffer = _Int16Stereo.buffer,
	          runtimeError = _Int16Stereo.error;
	
	      this.refs.editor.maybeAddError(runtimeError); // Throws
	
	      var link = document.createElement('a');
	      link.download = 'render.wav';
	      link.href = (0, _PCM.makeWAVURL)(buffer, 2, sampleRate);
	      link.click();
	
	      URL.revokeObjectURL(link.href);
	    }
	
	    /**/
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          fn = _state.fn,
	          length = _state.length,
	          renderTime = _state.renderTime,
	          isClean = _state.isClean;
	      var bufferLength = this.props.bufferLength;
	
	
	      var initialScript = history.state && history.state.source !== 'undefined' ? history.state.source : DEFAULT_SCRIPT;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'Musika-App',
	          onKeyDown: this.handleKeyDown.bind(this),
	          onKeyUp: this.handleKeyUp.bind(this),
	          onMouseDown: this.handleMouseDown.bind(this)
	          // {/*Make element focusable (or it won't catch kotkeys when clicked on empty zones)*/}
	          , tabIndex: '0'
	        },
	        _react2.default.createElement(_Player2.default, { ref: 'player', fn: fn, length: length, bufferLength: bufferLength,
	          audioCtx: this.audioCtx,
	          onPlayingChange: this.handlePlayingChange.bind(this),
	          onRenderTime: this.handleRenderTime.bind(this),
	          onError: this.handleError.bind(this)
	        }),
	        _react2.default.createElement(_CPULoad2.default, { renderTime: renderTime,
	          bufferLength: bufferLength,
	          sampleRate: this.audioCtx.sampleRate
	        }),
	        _react2.default.createElement(_Editor2.default, { ref: 'editor', defaultValue: initialScript }),
	        _react2.default.createElement(_BottomBar2.default, { ref: 'bottomBar',
	          isClean: isClean,
	          showRenderControls: typeof length !== 'undefined' && length > 0,
	          onUpdate: this.handleUpdate.bind(this),
	          onNew: this.handleNew.bind(this),
	          onSave: this.handleSave.bind(this),
	          onRender: this.handleRender.bind(this)
	        })
	      );
	    }
	  }]);
	
	  return App;
	}(_react2.default.Component);
	
	exports.default = App;
	
	
	App.propTypes = {
	  bufferLength: _propTypes2.default.number
	};
	
	App.defaultProps = {
	  bufferLength: 8192
	};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(3);
	
	var _examples = __webpack_require__(28);
	
	var _examples2 = _interopRequireDefault(_examples);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function ConfirmPanel(_ref) {
	  var title = _ref.title,
	      loadName = _ref.loadName,
	      onAccept = _ref.onAccept,
	      onCancel = _ref.onCancel;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    title ? _react2.default.createElement(
	      'h1',
	      null,
	      title
	    ) : null,
	    _react2.default.createElement(
	      'p',
	      null,
	      'This will delete ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'everything'
	      ),
	      ', including your undo history.',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'b',
	        null,
	        'It cannot be undone.'
	      )
	    ),
	    loadName ? _react2.default.createElement(
	      'p',
	      null,
	      'Discard all changes and load \xAB',
	      _react2.default.createElement(
	        'em',
	        null,
	        loadName
	      ),
	      '\xBB?'
	    ) : _react2.default.createElement(
	      'p',
	      null,
	      'Discard all changes?'
	    ),
	    _react2.default.createElement(
	      'button',
	      { onClick: onAccept },
	      'Accept'
	    ),
	    ' ',
	    _react2.default.createElement(
	      'button',
	      { onClick: onCancel },
	      'Cancel'
	    )
	  );
	}
	
	ConfirmPanel.propTypes = {
	  title: _propTypes2.default.string,
	  loadName: _propTypes2.default.string,
	  onAccept: _propTypes2.default.func.isRequired,
	  onCancel: _propTypes2.default.func.isRequired
	
	  //
	
	};function ButtonWithPanel(_ref2) {
	  var panel = _ref2.panel,
	      children = _ref2.children,
	      other = _objectWithoutProperties(_ref2, ['panel', 'children']);
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'panel-container' + (panel ? ' open' : '') },
	    panel ? _react2.default.createElement(
	      'div',
	      { className: 'panel' },
	      panel
	    ) : null,
	    _react2.default.createElement(
	      'button',
	      other,
	      children
	    )
	  );
	}
	
	ButtonWithPanel.propTypes = {
	  panel: _propTypes2.default.node
	
	  //
	
	};
	var BottomBar = function (_React$Component) {
	  _inherits(BottomBar, _React$Component);
	
	  function BottomBar(props) {
	    _classCallCheck(this, BottomBar);
	
	    var _this = _possibleConstructorReturn(this, (BottomBar.__proto__ || Object.getPrototypeOf(BottomBar)).call(this, props));
	
	    _this.state = {
	      newConfirming: false,
	      loadConfirming: false,
	      examplesOpen: false,
	      examplesConfirming: false,
	      renderSampleRate: 44100
	    };
	    return _this;
	  }
	
	  _createClass(BottomBar, [{
	    key: 'closePanels',
	    value: function closePanels() {
	      this.setState({
	        newConfirming: false,
	        loadConfirming: false,
	        examplesOpen: false,
	        examplesConfirming: false
	      });
	    }
	  }, {
	    key: 'handleNew',
	    value: function handleNew() {
	      if (this.props.isClean) {
	        this.handleNewConfirmed();
	      } else {
	        this.closePanels();
	        this.setState({ newConfirming: true });
	      }
	    }
	  }, {
	    key: 'handleNewConfirmed',
	    value: function handleNewConfirmed() {
	      this.props.onNew();
	      this.closePanels();
	    }
	  }, {
	    key: 'handleLoad',
	    value: function handleLoad() {
	      var _this2 = this;
	
	      var input = document.createElement('input');
	      input.type = 'file';
	      input.accept = '.musika,application/javascript';
	      input.onchange = function () {
	        var f = input.files[0];
	
	        if (!f) return;
	
	        var r = new FileReader();
	        r.onload = function (_ref3) {
	          var result = _ref3.target.result;
	
	          _this2.setState({
	            loadConfirming: {
	              name: f.name,
	              content: result
	            }
	          }, _this2.props.isClean ? _this2.handleLoadConfirmed : null);
	        };
	        r.readAsText(f);
	      };
	
	      input.click();
	    }
	  }, {
	    key: 'handleLoadConfirmed',
	    value: function handleLoadConfirmed() {
	      var source = this.state.loadConfirming.content.replace(/\r\n/g, '\n');
	      this.props.onNew(source);
	      this.closePanels();
	    }
	  }, {
	    key: 'handleSave',
	    value: function handleSave() {
	      this.props.onSave();
	      this.closePanels();
	    }
	  }, {
	    key: 'handleExamples',
	    value: function handleExamples() {
	      this.closePanels();
	      this.setState({ examplesOpen: true });
	    }
	  }, {
	    key: 'handleExamplesConfirmed',
	    value: function handleExamplesConfirmed() {
	      var source = _examples2.default[this.state.examplesConfirming];
	      this.props.onNew(source);
	      this.closePanels();
	    }
	  }, {
	    key: 'handleRender',
	    value: function handleRender() {
	      this.props.onRender(this.state.renderSampleRate);
	    }
	  }, {
	    key: 'handleRenderSampleRate',
	    value: function handleRenderSampleRate(_ref4) {
	      var value = _ref4.target.value;
	
	      this.setState({ renderSampleRate: value });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          newConfirming = _state.newConfirming,
	          loadConfirming = _state.loadConfirming,
	          examplesOpen = _state.examplesOpen,
	          examplesConfirming = _state.examplesConfirming,
	          renderSampleRate = _state.renderSampleRate;
	      var _props = this.props,
	          isClean = _props.isClean,
	          showRenderControls = _props.showRenderControls;
	
	
	      var updateControls = _react2.default.createElement(
	        'button',
	        { className: 'color-orange',
	          onClick: this.props.onUpdate,
	          title: 'CTRL-S',
	          'aria-label': 'Commit (CTRL-S)'
	        },
	        _react2.default.createElement(_Icon.Icon, { name: 'share' }),
	        ' Commit'
	      );
	
	      //
	
	      var newConfirmPanel = newConfirming ? _react2.default.createElement(ConfirmPanel, {
	        title: 'New script',
	        onAccept: this.handleNewConfirmed.bind(this),
	        onCancel: this.closePanels.bind(this)
	      }) : null;
	
	      var loadConfirmPanel = loadConfirming ? _react2.default.createElement(ConfirmPanel, {
	        title: 'Load file',
	        loadName: loadConfirming.name,
	        onAccept: this.handleLoadConfirmed.bind(this),
	        onCancel: this.closePanels.bind(this)
	      }) : null;
	
	      var examplesPanel = examplesOpen ? _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Examples'
	        ),
	        examplesConfirming === false ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'ul',
	            null,
	            Object.keys(_examples2.default).map(function (name) {
	              var onClick = function onClick(e) {
	                e.preventDefault();
	                _this3.setState({ examplesConfirming: name }, isClean ? _this3.handleExamplesConfirmed : null);
	              };
	
	              return _react2.default.createElement(
	                'li',
	                { key: name },
	                _react2.default.createElement(
	                  'a',
	                  { href: '', onClick: onClick },
	                  name
	                )
	              );
	            })
	          ),
	          _react2.default.createElement(
	            'button',
	            { onClick: this.closePanels.bind(this) },
	            'Close'
	          )
	        ) : _react2.default.createElement(ConfirmPanel, {
	          loadName: examplesConfirming,
	          onAccept: this.handleExamplesConfirmed.bind(this),
	          onCancel: this.closePanels.bind(this)
	        })
	      ) : null;
	
	      var fileControls = _react2.default.createElement(
	        'div',
	        { className: 'color-purple' },
	        _react2.default.createElement(
	          ButtonWithPanel,
	          { onClick: this.handleNew.bind(this),
	            panel: newConfirmPanel,
	            title: 'New',
	            'aria-label': 'New'
	          },
	          _react2.default.createElement(_Icon.Icon, { name: 'file' })
	        ),
	        _react2.default.createElement(
	          ButtonWithPanel,
	          { onClick: this.handleLoad.bind(this),
	            panel: loadConfirmPanel,
	            title: 'Load',
	            'aria-label': 'Load'
	          },
	          _react2.default.createElement(_Icon.IconStack, { icons: [{ name: 'file' }, { name: 'arrow-left', inverse: true, style: {
	                fontSize: '0.5em',
	                left: '-0.4em'
	              } }]
	          })
	        ),
	        _react2.default.createElement(
	          'button',
	          { onClick: this.handleSave.bind(this),
	            title: 'Save',
	            'aria-label': 'Save'
	          },
	          _react2.default.createElement(_Icon.IconStack, { icons: [{ name: 'file' }, { name: 'arrow-right', inverse: true, style: {
	                fontSize: '0.5em',
	                left: '-0.4em'
	              } }]
	          })
	        )
	      );
	
	      //
	
	      var exampleControls = _react2.default.createElement(
	        'div',
	        { className: 'color-blue' },
	        _react2.default.createElement(
	          ButtonWithPanel,
	          { onClick: this.handleExamples.bind(this),
	            panel: examplesPanel,
	            title: 'Examples',
	            'aria-label': 'Examples'
	          },
	          _react2.default.createElement(_Icon.Icon, { name: 'file-text' })
	        )
	      );
	
	      //
	
	      var renderControls = showRenderControls ? _react2.default.createElement(
	        'div',
	        { className: 'color-red' },
	        _react2.default.createElement(
	          'button',
	          { onClick: this.handleRender.bind(this),
	            title: 'Render',
	            'aria-label': 'Render'
	          },
	          _react2.default.createElement(_Icon.Icon, { name: 'download' }),
	          ' .WAV'
	        ),
	        _react2.default.createElement(
	          'select',
	          { onChange: this.handleRenderSampleRate.bind(this),
	            value: renderSampleRate,
	            title: 'Render sample rate',
	            'aria-label': 'Render sample rate'
	          },
	          _react2.default.createElement(
	            'option',
	            { value: 8000 },
	            '8000Hz'
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 11025 },
	            '11025Hz'
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 16000 },
	            '16000Hz'
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 22500 },
	            '22500Hz'
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 32000 },
	            '32000Hz'
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 37800 },
	            '37800Hz'
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 44100 },
	            '44100Hz'
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 48000 },
	            '48000Hz'
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 88200 },
	            '88200Hz'
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 96000 },
	            '96000Hz'
	          )
	        )
	      ) : null;
	
	      //
	
	      var aboutControls = _react2.default.createElement(
	        'a',
	        { className: 'github right',
	          href: 'https://www.github.com/alvaro-cuesta/lambda-musika',
	          target: '_blank'
	        },
	        _react2.default.createElement(_Icon.Icon, { name: 'github', title: 'alvaro-cuesta/lambda-musika at GitHub' })
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'panel-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'Musika-BottomBar' },
	          updateControls,
	          fileControls,
	          exampleControls,
	          renderControls,
	          aboutControls
	        )
	      );
	    }
	  }]);
	
	  return BottomBar;
	}(_react2.default.Component);
	
	exports.default = BottomBar;
	
	
	BottomBar.propTypes = {
	  isClean: _propTypes2.default.bool.isRequired,
	  showRenderControls: _propTypes2.default.bool.isRequired,
	  onUpdate: _propTypes2.default.func.isRequired,
	  onNew: _propTypes2.default.func.isRequired,
	  onSave: _propTypes2.default.func.isRequired,
	  onRender: _propTypes2.default.func.isRequired
	};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CPULoad;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// CPU load visualization. Given a buffer length, and a sample rate, shows how
	// much of the max render time is being used.
	function CPULoad(_ref) {
	  var renderTime = _ref.renderTime,
	      bufferLength = _ref.bufferLength,
	      sampleRate = _ref.sampleRate;
	
	  var maxRenderTimeLabel = '',
	      percentage = 0;
	
	  if (sampleRate && bufferLength) {
	    var maxRenderTime = Math.floor(1000 * bufferLength / sampleRate);
	
	    maxRenderTimeLabel = 'Max: ' + maxRenderTime + 'ms';
	    percentage = renderTime ? 100 * renderTime / maxRenderTime : 0;
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'Musika-CPULoad' },
	    _react2.default.createElement('div', { className: 'black', style: { minWidth: 100 - percentage + '%' } }),
	    _react2.default.createElement(
	      'span',
	      { className: 'left' },
	      'CPU',
	      renderTime ? ': ' + Math.floor(renderTime) + 'ms' : ''
	    ),
	    _react2.default.createElement(
	      'span',
	      { className: 'right' },
	      maxRenderTimeLabel
	    )
	  );
	}
	
	CPULoad.propTypes = {
	  renderTime: _propTypes2.default.number,
	  bufferLength: _propTypes2.default.number,
	  sampleRate: _propTypes2.default.number
	};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _brace = __webpack_require__(13);
	
	var _brace2 = _interopRequireDefault(_brace);
	
	__webpack_require__(14);
	
	__webpack_require__(15);
	
	__webpack_require__(9);
	
	__webpack_require__(11);
	
	__webpack_require__(8);
	
	__webpack_require__(10);
	
	__webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EMPTY_SCRIPT = __webpack_require__(44);
	
	var Editor = function (_React$PureComponent) {
	  _inherits(Editor, _React$PureComponent);
	
	  function Editor(props) {
	    _classCallCheck(this, Editor);
	
	    return _possibleConstructorReturn(this, (Editor.__proto__ || Object.getPrototypeOf(Editor)).call(this, props));
	  }
	
	  _createClass(Editor, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var editor = _brace2.default.edit(this.refs.editor);
	
	      editor.$blockScrolling = Infinity;
	
	      if (this.props.defaultValue) {
	        editor.setValue(this.props.defaultValue);
	        editor.gotoLine(0, 0, false);
	        editor.scrollToLine(0, false, false, function () {});
	      }
	      editor.getSession().setUndoManager(new _brace2.default.UndoManager());
	      editor.setOptions({
	        // Editor
	        selectionStyle: 'line',
	        highlightActiveLine: true,
	        highlightSelectedWord: true,
	        readOnly: false,
	        /*mergeUndoDeltas*/
	        cursorStyle: 'slim',
	        behavioursEnabled: true,
	        wrapBehavioursEnabled: true,
	        autoScrollEditorIntoView: false,
	
	        // Renderer
	        hScrollBarAlwaysVisible: false,
	        vScrollBarAlwaysVisible: false,
	        highlightGutterLine: true,
	        animatedScroll: false,
	        showInvisibles: false,
	        showPrintMargin: true,
	        printMarginColumn: 79,
	        //printMargin
	        fadeFoldWidgets: true,
	        showFoldWidgets: true,
	        showLineNumbers: true,
	        showGutter: true,
	        displayIndentGuides: true,
	        fontSize: '14px',
	        scrollPastEnd: true,
	        fixedWidthGutter: true,
	        theme: 'ace/theme/tomorrow_night_eighties',
	
	        // Session
	        useWorker: false,
	        useSoftTabs: true /*false?*/
	        , tabSize: 2,
	        wrap: false,
	        /*foldStyle*/
	        mode: 'ace/mode/javascript',
	
	        // Extensions
	        useElasticTabstops: true
	      });
	
	      if (this.props.onChange) {
	        editor.on('change', this.props.onChange);
	      }
	
	      _brace2.default.acequire('ace/ext/keybinding_menu').init(editor);
	
	      // HACK: This happens to fix magically the mispositioning of error markers
	      //       when loading the app for the first time
	      editor.renderer.on('resize', function () {
	        if (editor.getSession().getAnnotations().length > 0) {
	          _brace2.default.acequire('ace/ext/error_marker').showErrorMarker(editor, 1);
	        }
	      });
	
	      editor.getSession().on('changeAnnotation', function () {
	        // HACK: Wait for next tick so this is done _after_ setSerialState
	        //       Necessary because of setSerialState hack
	        setTimeout(function () {
	          editor.resize();
	          if (editor.getSession().getAnnotations().length > 0) {
	            _brace2.default.acequire('ace/ext/error_marker').showErrorMarker(editor, 1);
	            editor.focus();
	          }
	        }, 2);
	      });
	
	      editor.focus();
	
	      this.editor = editor;
	      if (this.props.onLoad) this.props.onLoad(editor);
	    }
	  }, {
	    key: 'new',
	    value: function _new(content) {
	      var editor = this.editor;
	      editor.setValue(typeof content !== 'undefined' ? content : EMPTY_SCRIPT);
	      editor.gotoLine(0, 0, false);
	      editor.getSession().setUndoManager(new _brace2.default.UndoManager());
	      editor.focus();
	    }
	  }, {
	    key: 'maybeAddError',
	    value: function maybeAddError(error) {
	      var editor = this.editor;
	      var source = editor.getValue();
	      var session = editor.getSession();
	
	      // Clear errors
	      session.setAnnotations();
	      if (session.lineWidgets) {
	        session.lineWidgets.forEach(function (w) {
	          session.widgetManager.removeLineWidget(w);
	        });
	      }
	
	      // Add new error
	      if (error) {
	        var name = error.name,
	            message = error.message,
	            row = error.row,
	            column = error.column;
	
	        var text = name + ': ' + message.replace(/\s+\(\d+:\d+\)$/, '');
	        session.setAnnotations([{ type: 'error', text: text, row: row, column: column }]);
	
	        console.error(error);
	        throw error.e;
	      }
	    }
	  }, {
	    key: 'setUndo',
	    value: function setUndo($undoStack, $redoStack, dirtyCounter) {
	      var undoManager = new _brace2.default.UndoManager();
	      var session = this.editor.getSession();
	
	      if (typeof $undoStack !== 'undefined' && typeof $redoStack !== 'undefined' && typeof dirtyCounter !== 'undefined') {
	        undoManager.$doc = session;
	        undoManager.$undoStack = $undoStack;
	        undoManager.$redoStack = $redoStack;
	        undoManager.dirtyCounter = dirtyCounter;
	      }
	
	      session.setUndoManager(undoManager);
	    }
	  }, {
	    key: 'getSerialState',
	    value: function getSerialState() {
	      var editor = this.editor;
	
	      var source = editor.getValue();
	      var cursor = editor.getCursorPosition();
	
	      var _editor$getSession$ge = editor.getSession().getUndoManager(),
	          $undoStack = _editor$getSession$ge.$undoStack,
	          $redoStack = _editor$getSession$ge.$redoStack,
	          dirtyCounter = _editor$getSession$ge.dirtyCounter;
	
	      return { source: source, cursor: cursor, $undoStack: $undoStack, $redoStack: $redoStack, dirtyCounter: dirtyCounter };
	    }
	  }, {
	    key: 'setSerialState',
	    value: function setSerialState(_ref) {
	      var source = _ref.source,
	          cursor = _ref.cursor,
	          $undoStack = _ref.$undoStack,
	          $redoStack = _ref.$redoStack,
	          dirtyCounter = _ref.dirtyCounter;
	
	      var editor = this.editor;
	
	      if (typeof source !== 'undefined') {
	        editor.setValue(source);
	      }
	
	      // HACK: Wait for next tick so resize works
	      setTimeout(function () {
	        editor.resize();
	
	        if (cursor) {
	          var row = cursor.row,
	              column = cursor.column;
	
	          editor.gotoLine(row + 1, column, false);
	          editor.scrollToLine(row + 1, true, false, function () {});
	        } else {
	          editor.gotoLine(0, 0, false);
	          editor.scrollToLine(0, false, false, function () {});
	        }
	
	        editor.focus();
	      }, 1);
	
	      this.setUndo($undoStack, $redoStack, dirtyCounter);
	    }
	  }, {
	    key: 'markDirty',
	    value: function markDirty() {
	      this.editor.getSession().getUndoManager().dirtyCounter = NaN;
	    }
	  }, {
	    key: 'markClean',
	    value: function markClean() {
	      this.editor.getSession().getUndoManager().markClean();
	    }
	  }, {
	    key: 'isClean',
	    value: function isClean() {
	      return this.editor.getSession().getUndoManager().isClean();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('div', { ref: 'editor', className: 'Musika-Editor' });
	    }
	  }]);
	
	  return Editor;
	}(_react2.default.PureComponent);
	
	exports.default = Editor;
	
	
	Editor.propTypes = {
	  defaultValue: _propTypes2.default.string,
	  onLoad: _propTypes2.default.func
	};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TimeSlider = __webpack_require__(26);
	
	var _TimeSlider2 = _interopRequireDefault(_TimeSlider);
	
	var _TimeSeeker = __webpack_require__(25);
	
	var _TimeSeeker2 = _interopRequireDefault(_TimeSeeker);
	
	var _Icon = __webpack_require__(3);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ScriptProcessorPlayer = __webpack_require__(37);
	
	var _ScriptProcessorPlayer2 = _interopRequireDefault(_ScriptProcessorPlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Audio player component which receives a function `fn` to generate audio
	var Player = function (_React$PureComponent) {
	  _inherits(Player, _React$PureComponent);
	
	  function Player(props) {
	    _classCallCheck(this, Player);
	
	    var _this = _possibleConstructorReturn(this, (Player.__proto__ || Object.getPrototypeOf(Player)).call(this, props));
	
	    _this.newFnPlayer(props);
	
	    _this.state = {
	      playing: false,
	      lastFrame: 0
	    };
	    return _this;
	  }
	
	  /* Public API */
	
	  _createClass(Player, [{
	    key: 'play',
	    value: function play() {
	      this.fnPlayer.play();
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.fnPlayer.pause();
	    }
	  }, {
	    key: 'togglePlay',
	    value: function togglePlay() {
	      this.fnPlayer.togglePlay();
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      this.fnPlayer.stop();
	    }
	
	    /* Private API and lifecycle */
	
	  }, {
	    key: 'newFnPlayer',
	    value: function newFnPlayer(_ref, playing, lastFrame) {
	      var audioCtx = _ref.audioCtx,
	          bufferLength = _ref.bufferLength,
	          fn = _ref.fn,
	          length = _ref.length,
	          onRenderTime = _ref.onRenderTime,
	          onError = _ref.onError;
	
	      if (this.fnPlayer) {
	        this.fnPlayer.onPlayingChange = undefined; // Do not notify of stop...
	        this.fnPlayer.stop(); // ..because we just want to detroy and recreate
	      }
	
	      this.fnPlayer = new _ScriptProcessorPlayer2.default(audioCtx, bufferLength, fn, length, playing, lastFrame);
	      this.fnPlayer.onPlayingChange = this.handlePlayingChange.bind(this);
	      this.fnPlayer.onFrame = this.handleFrame.bind(this);
	      this.fnPlayer.onRenderTime = onRenderTime;
	      this.fnPlayer.onError = onError;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.audioCtx !== nextProps.audioCtx || this.props.bufferLength !== nextProps.bufferLength) {
	        var _state = this.state,
	            playing = _state.playing,
	            lastFrame = _state.lastFrame;
	
	        this.newFnPlayer(nextProps, playing, lastFrame);
	      }
	
	      if (this.props.fn !== nextProps.fn) {
	        this.fnPlayer.setFunction(nextProps.fn);
	      }
	
	      if (this.props.length !== nextProps.length) {
	        this.fnPlayer.setLength(nextProps.length);
	      }
	
	      if (this.props.onRenderTime !== nextProps.onRenderTime) {
	        this.fnPlayer.onRenderTime = nextProps.onRenderTime;
	      }
	
	      if (this.props.onError !== nextProps.onError) {
	        this.fnPlayer.onError = nextProps.onError;
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.fnPlayer.stop();
	    }
	
	    // Handle seeking from controls
	
	  }, {
	    key: 'handleTime',
	    value: function handleTime(time) {
	      var lastFrame = time * this.props.audioCtx.sampleRate;
	      this.fnPlayer.setFrame(lastFrame);
	      this.setState({ lastFrame: lastFrame });
	    }
	
	    // Handle frame updates as time progresses
	
	  }, {
	    key: 'handleFrame',
	    value: function handleFrame(lastFrame) {
	      this.setState({ lastFrame: lastFrame });
	    }
	  }, {
	    key: 'handlePlayingChange',
	    value: function handlePlayingChange(playing) {
	      this.setState({ playing: playing });
	      this.props.onPlayingChange(playing);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state2 = this.state,
	          playing = _state2.playing,
	          lastFrame = _state2.lastFrame;
	      var _props = this.props,
	          sampleRate = _props.audioCtx.sampleRate,
	          fn = _props.fn,
	          length = _props.length;
	
	
	      var title = (playing ? 'Pause' : 'Play') + ' (CTRL-Space)';
	      var hasFn = typeof fn !== 'undefined';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'Musika-Player' },
	        _react2.default.createElement(
	          'button',
	          { onClick: this.togglePlay.bind(this),
	            className: hasFn ? 'color-orange' : 'color-grey',
	            disabled: !hasFn,
	            title: title,
	            'aria-label': title
	          },
	          _react2.default.createElement(_Icon2.default, { name: playing ? 'pause' : 'play' })
	        ),
	        hasFn ? length ? _react2.default.createElement(_TimeSlider2.default, { length: length, value: lastFrame / sampleRate, onChange: this.handleTime.bind(this) }) : _react2.default.createElement(_TimeSeeker2.default, { value: lastFrame / sampleRate, onChange: this.handleTime.bind(this) }) : null
	      );
	    }
	  }]);
	
	  return Player;
	}(_react2.default.PureComponent);
	
	exports.default = Player;
	
	
	var AudioContext = window.AudioContext || window.webkitAudioContext;
	Player.propTypes = {
	  audioCtx: _propTypes2.default.instanceOf(AudioContext).isRequired,
	  fn: _propTypes2.default.func,
	  length: _propTypes2.default.number,
	  bufferLength: _propTypes2.default.number,
	  onPlayingChange: _propTypes2.default.func,
	  onRenderTime: _propTypes2.default.func,
	  onError: _propTypes2.default.func
	};
	
	Player.defaultProps = {
	  bufferLength: 8192
	};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(3);
	
	var _util = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var REWIND_FF_SECS = 5;
	var VERY_FF_SECS = 60;
	
	var TimeSeeker = function (_React$PureComponent) {
	  _inherits(TimeSeeker, _React$PureComponent);
	
	  function TimeSeeker() {
	    _classCallCheck(this, TimeSeeker);
	
	    return _possibleConstructorReturn(this, (TimeSeeker.__proto__ || Object.getPrototypeOf(TimeSeeker)).apply(this, arguments));
	  }
	
	  _createClass(TimeSeeker, [{
	    key: 'handleRestart',
	    value: function handleRestart() {
	      var onChange = this.props.onChange;
	
	
	      if (typeof onChange !== 'undefined') {
	        onChange(0);
	      }
	    }
	  }, {
	    key: 'handleRewind',
	    value: function handleRewind() {
	      var _props = this.props,
	          value = _props.value,
	          onChange = _props.onChange;
	
	
	      if (typeof onChange !== 'undefined') {
	        onChange(Math.max(0, value - REWIND_FF_SECS));
	      }
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(_ref) {
	      var value = _ref.target.value;
	      var onChange = this.props.onChange;
	
	      var _value$split$map = value.split(':').map(function (n) {
	        return parseInt(n, 10);
	      }),
	          _value$split$map2 = _slicedToArray(_value$split$map, 2),
	          mins = _value$split$map2[0],
	          secs = _value$split$map2[1];
	
	      if (typeof onChange !== 'undefined') {
	        onChange(mins * 60 + secs);
	      }
	    }
	  }, {
	    key: 'handleFastForward',
	    value: function handleFastForward() {
	      var _props2 = this.props,
	          value = _props2.value,
	          onChange = _props2.onChange;
	
	
	      if (typeof onChange !== 'undefined') {
	        onChange(value + REWIND_FF_SECS);
	      }
	    }
	  }, {
	    key: 'handleVeryFastForward',
	    value: function handleVeryFastForward() {
	      var _props3 = this.props,
	          value = _props3.value,
	          onChange = _props3.onChange;
	
	
	      if (typeof onChange !== 'undefined') {
	        onChange(value + VERY_FF_SECS);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          value = _props4.value,
	          onChange = _props4.onChange;
	
	
	      var restartLabel = 'Restart';
	      var rewindLabel = '-' + REWIND_FF_SECS + ' seconds';
	      var timeLabel = 'Time';
	      var forwardLabel = '+' + REWIND_FF_SECS + ' seconds';
	      var fastForwardLabel = '+' + VERY_FF_SECS + ' seconds';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'Musika-TimeSeeker' },
	        _react2.default.createElement(
	          'button',
	          { className: 'color-purple',
	            onClick: this.handleRestart.bind(this),
	            title: restartLabel,
	            'aria-label': restartLabel
	          },
	          _react2.default.createElement(_Icon.Icon, { name: 'fast-backward' })
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'color-green',
	            onClick: this.handleRewind.bind(this),
	            title: rewindLabel,
	            'aria-label': rewindLabel
	          },
	          _react2.default.createElement(_Icon.Icon, { name: 'backward' })
	        ),
	        _react2.default.createElement('input', { className: 'color-yellow', type: 'time', value: (0, _util.toMinSecs)(value), required: true,
	          onChange: this.handleChange.bind(this),
	          title: timeLabel,
	          'aria-label': timeLabel
	        }),
	        _react2.default.createElement(
	          'button',
	          { className: 'color-blue',
	            onClick: this.handleFastForward.bind(this),
	            title: forwardLabel,
	            'aria-label': forwardLabel
	          },
	          _react2.default.createElement(_Icon.Icon, { name: 'forward' })
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'color-red',
	            onClick: this.handleVeryFastForward.bind(this),
	            title: fastForwardLabel,
	            'aria-label': fastForwardLabel
	          },
	          _react2.default.createElement(_Icon.IconStack, { style: { top: '-2px', left: '1px' }, icons: [{ name: 'forward', style: { left: '-0.2em' } }, { name: 'forward', style: { left: '0.2em' } }]
	          })
	        )
	      );
	    }
	  }]);
	
	  return TimeSeeker;
	}(_react2.default.PureComponent);
	
	exports.default = TimeSeeker;
	
	
	TimeSeeker.propTypes = {
	  value: _propTypes2.default.number,
	  onChange: _propTypes2.default.func
	};
	
	TimeSeeker.defaultProps = {
	  value: 0
	};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _util = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// A slider component to seek time
	var TimeSlider = function (_React$PureComponent) {
	  _inherits(TimeSlider, _React$PureComponent);
	
	  function TimeSlider() {
	    _classCallCheck(this, TimeSlider);
	
	    return _possibleConstructorReturn(this, (TimeSlider.__proto__ || Object.getPrototypeOf(TimeSlider)).apply(this, arguments));
	  }
	
	  _createClass(TimeSlider, [{
	    key: 'handleChange',
	
	    // Regular change event
	    value: function handleChange(_ref) {
	      var value = _ref.target.value;
	      var onChange = this.props.onChange;
	
	
	      if (typeof onChange !== 'undefined') {
	        onChange(value);
	      }
	    }
	
	    // Also allow changing value by sliding
	
	  }, {
	    key: 'handleMouseDown',
	    value: function handleMouseDown() {
	      this.isSliding = true;
	    }
	  }, {
	    key: 'handleMouseUp',
	    value: function handleMouseUp(_ref2) {
	      var value = _ref2.target.value;
	      var onChange = this.props.onChange;
	
	
	      this.isSliding = false;
	      if (typeof onChange !== 'undefined') {
	        onChange(value);
	      }
	    }
	  }, {
	    key: 'handleMouseMove',
	    value: function handleMouseMove(_ref3) {
	      var value = _ref3.target.value;
	      var onChange = this.props.onChange;
	
	
	      if (this.isSliding && typeof onChange !== 'undefined') {
	        onChange(value);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          length = _props.length,
	          value = _props.value,
	          onChange = _props.onChange,
	          other = _objectWithoutProperties(_props, ['length', 'value', 'onChange']);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'Musika-TimeSlider' },
	        (0, _util.toMinSecs)(Math.floor(value)),
	        _react2.default.createElement('input', _extends({}, other, {
	          type: 'range', min: '0', max: length, value: value,
	          onChange: this.handleChange.bind(this),
	          onMouseDown: this.handleMouseDown.bind(this),
	          onMouseUp: this.handleMouseUp.bind(this),
	          onMouseMove: this.handleMouseMove.bind(this)
	        })),
	        (0, _util.toMinSecs)(length)
	      );
	    }
	  }]);
	
	  return TimeSlider;
	}(_react2.default.PureComponent);
	
	exports.default = TimeSlider;
	
	
	TimeSlider.propTypes = {
	  length: _propTypes2.default.number,
	  value: _propTypes2.default.number,
	  onChange: _propTypes2.default.func
	};
	
	TimeSlider.defaultProps = {
	  value: 0,
	  length: 0
	};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(18);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	__webpack_require__(39);
	
	var _App = __webpack_require__(20);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_reactDom2.default.render(_react2.default.createElement(_App2.default, null), document.getElementById('container'));
	
	/*
	
	ALTERNATE RENDER METHOD
	
	Instead of using ScriptProcessorNode. Worth considering again.
	
	function StereoBuffer(/*sampleRate, */ /*length, fn) {
	                                       let frameCount = Math.floor(length * audioCtx.sampleRate);
	                                       let buffer = audioCtx.createBuffer(2, frameCount, audioCtx.sampleRate);
	                                       let lChannel = buffer.getChannelData(0);
	                                       let rChannel = buffer.getChannelData(1);
	                                       for (let i = 0; i < frameCount; i++) {
	                                       let t = i/audioCtx.sampleRate;
	                                       let [l, r] = fn(t);
	                                       lChannel[i] = l;
	                                       rChannel[i] = r;
	                                       }
	                                       return buffer;
	                                       }
	                                       let source = audioCtx.createBufferSource();
	                                       source.buffer = StereoBuffer(SONG_LENGTH, makeComposition());
	                                       source.connect(audioCtx.destination);
	                                       source.start();
	                                       */

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'Default': __webpack_require__(17),
	  'Binaural Beat': __webpack_require__(43),
	  'Filtered Noise': __webpack_require__(46),
	  'Sea': __webpack_require__(48),
	  'Exhale': __webpack_require__(45),
	  'Arpeggio + Sequencer': __webpack_require__(42),
	  'THX Clone': __webpack_require__(49),
	  'Popping (WIP)': __webpack_require__(47)
	};

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.attack = attack;
	exports.invAttack = invAttack;
	exports.release = release;
	exports.invRelease = invRelease;
	exports.linear = linear;
	/* Envelopes */
	
	// Attack function that grows quickly from `[0, 0]` to `[length, 1]` in a concave
	// shape.
	//
	// `curve` controls the exponential strength.
	//
	//      __
	//     /
	// ,.·´
	function attack(length, curve, t) {
	  if (typeof t === 'undefined') {
	    t = curve;
	    curve = 2;
	  }
	
	  return t < length ? Math.pow(t / length, curve) : 1;
	}
	
	// Attack function that grows slowly from `[0, 0]` to `[length, 1]` in a convex
	// shape.
	//
	// `curve` controls the exponential strength.
	//
	//      __
	//  ,·´
	// /
	function invAttack(length, curve, t) {
	  if (typeof t === 'undefined') {
	    t = curve;
	    curve = 2;
	  }
	
	  return t < length ? 1 - Math.pow(1 - t / length, curve) : 1;
	}
	
	// Release function that stays at 1 from `[0, 1]` to [`releaseTime`, 1] and then
	// decays quickly from `[releaseTime, 1]` to `[totalTime, 0]` in a concave shape.
	//
	// `curve` controls the exponential strength.
	//
	// __
	//   \
	//    `·.,_
	function release(releaseTime, totalTime, curve, t) {
	  if (typeof t === 'undefined') {
	    t = curve;
	    curve = 2;
	  }
	
	  if (t > totalTime) return 0;
	  var releaseStart = totalTime - releaseTime;
	  if (t <= releaseStart) return 1;
	
	  return Math.pow((releaseTime - (t - releaseStart)) / releaseTime, curve);
	}
	
	// Release function that stays at 1 from `[0, 1]` to [`releaseTime`, 1] and then
	// decays slowly from `[releaseTime, 1]` to `[totalTime, 0]` in a convex shape.
	//
	// `curve` controls the exponential strength.
	//
	// __
	//    `·.
	//       \_
	function invRelease(releaseTime, totalTime, curve, t) {
	  if (typeof t === 'undefined') {
	    t = curve;
	    curve = 2;
	  }
	
	  if (t > totalTime) return 0;
	  var releaseStart = totalTime - releaseTime;
	  if (t <= releaseStart) return 1;
	
	  return 1 - Math.pow((t - releaseStart) / releaseTime, curve);
	}
	
	// Linearly-interpolated envelope, decribed by a set of `[x, y]` points.
	// When `x < x0` outputs `y0`. When `x > xn` outputs `yn`.
	function linear(points, t) {
	  for (var i = 0; i < points.length; i++) {
	    var _points$i = _slicedToArray(points[i], 2),
	        x1 = _points$i[0],
	        y1 = _points$i[1];
	
	    if (t < x1) {
	      if (i === 0) {
	        return y1;
	      }
	
	      var _points = _slicedToArray(points[i - 1], 2),
	          x0 = _points[0],
	          y0 = _points[1];
	
	      return y0 + (y1 - y0) * (t - x0) / (x1 - x0);
	    }
	  }
	
	  return points[points.length - 1][1];
	}

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = Biquad;
	function Biquad() {
	  var z1 = 0;
	  var z2 = 0;
	
	  return function (_ref, input) {
	    var _ref2 = _slicedToArray(_ref, 5),
	        a0 = _ref2[0],
	        a1 = _ref2[1],
	        a2 = _ref2[2],
	        b1 = _ref2[3],
	        b2 = _ref2[4];
	
	    var output = input * a0 + z1;
	    z1 = input * a1 + z2 - b1 * output;
	    z2 = input * a2 - b2 * output;
	
	    return output;
	  };
	}
	
	Biquad.LP = function biquadLP(cutoff, Q) {
	  var K = Math.tan(Math.PI * cutoff);
	
	  var norm = 1 / (1 + K / Q + K * K);
	  var a0 = K * K * norm;
	  var a1 = 2 * a0;
	  var a2 = a0;
	  var b1 = 2 * (K * K - 1) * norm;
	  var b2 = (1 - K / Q + K * K) * norm;
	
	  return [a0, a1, a2, b1, b2];
	};
	
	Biquad.HP = function biquadHP(cutoff, Q) {
	  var K = Math.tan(Math.PI * cutoff);
	
	  var norm = 1 / (1 + K / Q + K * K);
	  var a0 = 1 * norm;
	  var a1 = -2 * a0;
	  var a2 = a0;
	  var b1 = 2 * (K * K - 1) * norm;
	  var b2 = (1 - K / Q + K * K) * norm;
	
	  return [a0, a1, a2, b1, b2];
	};
	
	Biquad.BP = function biquadBP(cutoff, Q) {
	  var K = Math.tan(Math.PI * cutoff);
	
	  var norm = 1 / (1 + K / Q + K * K);
	  var a0 = K / Q * norm;
	  var a1 = 0;
	  var a2 = -a0;
	  var b1 = 2 * (K * K - 1) * norm;
	  var b2 = (1 - K / Q + K * K) * norm;
	
	  return [a0, a1, a2, b1, b2];
	};
	
	Biquad.Notch = function biquadNotch(cutoff, Q) {
	  var K = Math.tan(Math.PI * cutoff);
	
	  var norm = 1 / (1 + K / Q + K * K);
	  var a0 = (1 + K * K) * norm;
	  var a1 = 2 * (K * K - 1) * norm;
	  var a2 = a0;
	  var b1 = a1;
	  var b2 = (1 - K / Q + K * K) * norm;
	
	  return [a0, a1, a2, b1, b2];
	};
	
	Biquad.Peak = function biquadPeak(cutoff, Q, peakGain) {
	  var V = Math.pow(10, Math.abs(peakGain) / 20);
	  var K = Math.tan(Math.PI * cutoff);
	
	  if (peakGain >= 0) {
	    // boost
	    var norm = 1 / (1 + 1 / Q * K + K * K);
	    var a0 = (1 + V / Q * K + K * K) * norm;
	    var a1 = 2 * (K * K - 1) * norm;
	    var a2 = (1 - V / Q * K + K * K) * norm;
	    var b1 = a1;
	    var b2 = (1 - 1 / Q * K + K * K) * norm;
	
	    return [a0, a1, a2, b1, b2];
	  } else {
	    // cut
	    var _norm = 1 / (1 + V / Q * K + K * K);
	    var _a = (1 + 1 / Q * K + K * K) * _norm;
	    var _a2 = 2 * (K * K - 1) * _norm;
	    var _a3 = (1 - 1 / Q * K + K * K) * _norm;
	    var _b = _a2;
	    var _b2 = (1 - V / Q * K + K * K) * _norm;
	
	    return [_a, _a2, _a3, _b, _b2];
	  }
	};
	
	Biquad.LowShelf = function biquadLowShelf(cutoff, peakGain) {
	  var V = Math.pow(10, Math.abs(peakGain) / 20);
	  var K = Math.tan(Math.PI * cutoff);
	
	  if (peakGain >= 0) {
	    // boost
	    var norm = 1 / (1 + Math.SQRT2 * K + K * K);
	    var a0 = (1 + Math.sqrt(2 * V) * K + V * K * K) * norm;
	    var a1 = 2 * (V * K * K - 1) * norm;
	    var a2 = (1 - Math.sqrt(2 * V) * K + V * K * K) * norm;
	    var b1 = 2 * (K * K - 1) * norm;
	    var b2 = (1 - Math.SQRT2 * K + K * K) * norm;
	
	    return [a0, a1, a2, b1, b2];
	  } else {
	    // cut
	    var _norm2 = 1 / (1 + Math.sqrt(2 * V) * K + V * K * K);
	    var _a4 = (1 + Math.SQRT2 * K + K * K) * _norm2;
	    var _a5 = 2 * (K * K - 1) * _norm2;
	    var _a6 = (1 - Math.SQRT2 * K + K * K) * _norm2;
	    var _b3 = 2 * (V * K * K - 1) * _norm2;
	    var _b4 = (1 - Math.sqrt(2 * V) * K + V * K * K) * _norm2;
	
	    return [_a4, _a5, _a6, _b3, _b4];
	  }
	};
	
	Biquad.HighShelf = function biquadHighShelf(cutoff, peakGain) {
	  var V = Math.pow(10, Math.abs(peakGain) / 20);
	  var K = Math.tan(Math.PI * cutoff);
	
	  if (peakGain >= 0) {
	    // boost
	    var norm = 1 / (1 + Math.SQRT2 * K + K * K);
	    var a0 = (V + Math.sqrt(2 * V) * K + K * K) * norm;
	    var a1 = 2 * (K * K - V) * norm;
	    var a2 = (V - Math.sqrt(2 * V) * K + K * K) * norm;
	    var b1 = 2 * (K * K - 1) * norm;
	    var b2 = (1 - Math.SQRT2 * K + K * K) * norm;
	
	    return [a0, a1, a2, b1, b2];
	  } else {
	    // cut
	    var _norm3 = 1 / (V + Math.sqrt(2 * V) * K + K * K);
	    var _a7 = (1 + Math.SQRT2 * K + K * K) * _norm3;
	    var _a8 = 2 * (K * K - 1) * _norm3;
	    var _a9 = (1 - Math.SQRT2 * K + K * K) * _norm3;
	    var _b5 = 2 * (K * K - V) * _norm3;
	    var _b6 = (V - Math.sqrt(2 * V) * K + K * K) * _norm3;
	
	    return [_a7, _a8, _a9, _b5, _b6];
	  }
	};

/***/ }),
/* 31 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Sin = Sin;
	exports.PositiveSaw = PositiveSaw;
	exports.Saw = Saw;
	exports.PositiveSquare = PositiveSquare;
	exports.Square = Square;
	exports.Tri = Tri;
	exports.LFNoise1 = LFNoise1;
	exports.random = random;
	/* Generators */
	
	function Sin() {
	  var phase = 0;
	  var lastT = 0;
	
	  return function sin(f, t) {
	    phase += 2 * Math.PI * f * (t - lastT);
	    phase %= 2 * Math.PI;
	    lastT = t;
	    return Math.sin(phase);
	  };
	}
	
	function PositiveSaw() {
	  var phase = 0;
	  var lastT = 0;
	
	  return function positiveSaw(f, t) {
	    phase += (t - lastT) % (1 / f) * f;
	    phase %= 1;
	    lastT = t;
	    return phase;
	  };
	}
	
	function Saw() {
	  var osc = PositiveSaw();
	
	  return function saw(f, t) {
	    return osc(f, t) * 2 - 1;
	  };
	}
	
	function PositiveSquare() {
	  var osc = PositiveSaw();
	
	  return function positiveSquare(f, pw, t) {
	    if (typeof t === 'undefined') {
	      t = pw;
	      pw = 0.5;
	    }
	
	    return osc(f, t) > pw ? 1 : 0;
	  };
	}
	
	function Square() {
	  var osc = PositiveSaw();
	
	  return function square(f, pw, t) {
	    if (typeof t === 'undefined') {
	      t = pw;
	      pw = 0.5;
	    }
	
	    return osc(f, t) > pw ? 1 : -1;
	  };
	}
	
	function Tri() {
	  var osc = PositiveSaw();
	
	  return function tri(f, t) {
	    var pos = osc(f, t);
	
	    return (pos <= 0.5 ? pos : 1 - pos) * 4 - 1;
	  };
	}
	
	function LFNoise1(f) {
	  var period = 1 / f;
	  var last_update = 0;
	
	  var y0 = Math.random();
	  var y1 = Math.random();
	
	  var slope = (y1 - y0) / period;
	
	  return function (t) {
	    if (t > last_update + period) {
	      y0 = y1;
	      y1 = Math.random();
	      slope = (y1 - y0) / period;
	      last_update += period;
	    }
	
	    return y0 + (t - last_update) * slope;
	  };
	}
	
	function random() {
	  return Math.random() * 2 - 1;
	}

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.semitoneToFrequency = semitoneToFrequency;
	exports.Tempo = Tempo;
	exports.extend = extend;
	/* Built-in music utilities */
	
	var SEMITONES_PER_OCTAVE = 12;
	var A = Math.pow(2, 1 / SEMITONES_PER_OCTAVE);
	var BASE_FREQ = 440; // A4 = 440Hz
	var LOWEST_SEMITONE_DIFF_FROM_BASE = -57; // C0 = -57 semitones from A4
	var OCTAVES = [0, 1, 2, 3, 4, 5, 6, 7, 8];
	var PITCHES = { 'C': 0, 'D': 2, 'E': 4, 'F': 5, 'G': 7, 'A': 9, 'B': 11 };
	var ACCIDENTALS = {
	  'bb': -2,
	  '♭♭': -2,
	  '𝄫': -2,
	  'b': -1,
	  '♭': -1,
	  '': 0,
	  '♮': 0,
	  '♯': 1,
	  '#': 1,
	  '♯♯': 2,
	  '##': 2,
	  '𝄪': 2
	};
	
	exports.SEMITONES_PER_OCTAVE = SEMITONES_PER_OCTAVE;
	exports.A = A;
	exports.BASE_FREQ = BASE_FREQ;
	exports.LOWEST_SEMITONE_DIFF_FROM_BASE = LOWEST_SEMITONE_DIFF_FROM_BASE;
	exports.OCTAVES = OCTAVES;
	exports.PITCHES = PITCHES;
	exports.ACCIDENTALS = ACCIDENTALS;
	function semitoneToFrequency(semitonesFromBaseTone) {
	  return BASE_FREQ * Math.pow(A, semitonesFromBaseTone);
	}
	
	var noteNameToSemitone = {};
	var noteNameToFrequency = {};
	
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;
	
	try {
	  for (var _iterator = OCTAVES[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	    var octave = _step.value;
	    var _iteratorNormalCompletion5 = true;
	    var _didIteratorError5 = false;
	    var _iteratorError5 = undefined;
	
	    try {
	      for (var _iterator5 = Object.keys(PITCHES)[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	        var pitch = _step5.value;
	        var _iteratorNormalCompletion6 = true;
	        var _didIteratorError6 = false;
	        var _iteratorError6 = undefined;
	
	        try {
	          for (var _iterator6 = Object.keys(ACCIDENTALS)[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	            var accidental = _step6.value;
	
	            var noteName = '' + pitch + accidental + octave;
	            var absoluteSemitone = LOWEST_SEMITONE_DIFF_FROM_BASE + octave * SEMITONES_PER_OCTAVE + PITCHES[pitch] + ACCIDENTALS[accidental];
	
	            noteNameToSemitone[noteName] = absoluteSemitone;
	            noteNameToFrequency[noteName] = semitoneToFrequency(absoluteSemitone);
	          }
	        } catch (err) {
	          _didIteratorError6 = true;
	          _iteratorError6 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion6 && _iterator6.return) {
	              _iterator6.return();
	            }
	          } finally {
	            if (_didIteratorError6) {
	              throw _iteratorError6;
	            }
	          }
	        }
	      }
	    } catch (err) {
	      _didIteratorError5 = true;
	      _iteratorError5 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion5 && _iterator5.return) {
	          _iterator5.return();
	        }
	      } finally {
	        if (_didIteratorError5) {
	          throw _iteratorError5;
	        }
	      }
	    }
	  }
	} catch (err) {
	  _didIteratorError = true;
	  _iteratorError = err;
	} finally {
	  try {
	    if (!_iteratorNormalCompletion && _iterator.return) {
	      _iterator.return();
	    }
	  } finally {
	    if (_didIteratorError) {
	      throw _iteratorError;
	    }
	  }
	}
	
	exports.noteNameToSemitone = noteNameToSemitone;
	exports.noteNameToFrequency = noteNameToFrequency;
	function Tempo(bpb, bv, bpm) {
	  var beatLength = 60 / bpm;
	  var barLength = bpb * beatLength;
	
	  function timeInBar(t) {
	    return t % barLength;
	  }
	
	  function currentBar(t) {
	    return 1 + Math.floor(t / barLength);
	  }
	
	  function noteLength() {
	    var noteValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : bv;
	
	    return beatLength * bv / noteValue;
	  }
	
	  function timeInNote(noteValue, t) {
	    if (typeof t === 'undefined') {
	      t = noteValue;
	      noteValue = bv;
	    }
	
	    return t % noteLength(noteValue);
	  }
	
	  function currentNoteInBar(noteValue, t) {
	    if (typeof t === 'undefined') {
	      t = noteValue;
	      noteValue = bv;
	    }
	
	    return 1 + Math.floor(timeInBar(t) / noteLength(noteValue));
	  }
	
	  function isInBar(which, noteValue, t) {
	    return which.indexOf(currentNoteInBar(noteValue, t)) !== -1;
	  }
	
	  return {
	    beatLength: beatLength,
	    barLength: barLength,
	    timeInBar: timeInBar,
	    currentBar: currentBar,
	    noteLength: noteLength,
	    timeInNote: timeInNote,
	    currentNoteInBar: currentNoteInBar,
	    isInBar: isInBar
	  };
	}
	
	var interval = {
	  'unison': 0,
	  '1': 0,
	  'P1': 0,
	  'm2': 1,
	  '2': 2,
	  'M2': 2,
	  'm3': 3,
	  '3': 4,
	  'M3': 4,
	  '4': 5,
	  'P4': 5,
	  '#4': 6,
	  '♯4': 6,
	  'A4': 6,
	  'TT': 6,
	  'b5': 6,
	  '♭5': 6,
	  'd5': 6,
	  '5': 7,
	  'P5': 7,
	  'A5': 8,
	  'm6': 8,
	  '6': 9,
	  'M6': 9,
	  'd7': 9,
	  'm7': 10,
	  '7': 11,
	  'M7': 11,
	  'octave': 12,
	  '8': 12,
	  'P8': 12,
	  'm9': 13,
	  'b9': 13,
	  '♭9': 13,
	  '9': 14,
	  '#9': 15,
	  '♯9': 15,
	  '11': 17,
	  '#11': 18,
	  '♯11': 18,
	  '13': 21
	};
	
	var chord = {};
	
	// Triads
	chord[''] = ['1', '3', '5'];
	chord['m'] = ['1', 'm3', '5'];
	chord['+'] = ['1', '3', 'A5'];
	chord['dim'] = ['1', 'm3', 'd5'];
	chord['sus2'] = ['1', '2', '5'];
	chord['sus4'] = ['1', '4', '5'];
	
	// 7th tetrads
	chord['maj7'] = ['1', '3', '5', '7'];
	chord['7'] = ['1', '3', '5', 'm7'];
	chord['+7'] = ['1', '3', 'A5', 'm7'];
	chord['m7'] = ['1', 'm3', '5', 'm7'];
	chord['mM7'] = ['1', 'm3', '5', '7'];
	chord['m7b5'] = ['1', 'm3', 'd5', 'm7'];
	chord['dim7'] = ['1', 'm3', 'd5', 'd7'];
	
	// Extended
	chord['9'] = ['1', 'm3', 'd5', 'd7', '9'];
	chord['13'] = ['1', 'm3', 'd5', 'd7', '9', '13'];
	
	// Other
	chord['5'] = ['1', '5', '8'];
	
	var _iteratorNormalCompletion2 = true;
	var _didIteratorError2 = false;
	var _iteratorError2 = undefined;
	
	try {
	  for (var _iterator2 = Object.keys(chord)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	    var name = _step2.value;
	
	    chord[name] = chord[name].map(function (i) {
	      return interval[i];
	    });
	  }
	
	  // Aliases
	} catch (err) {
	  _didIteratorError2 = true;
	  _iteratorError2 = err;
	} finally {
	  try {
	    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	      _iterator2.return();
	    }
	  } finally {
	    if (_didIteratorError2) {
	      throw _iteratorError2;
	    }
	  }
	}
	
	chord['M'] = chord['maj'] = chord['Maj'] = chord['Δ'] = chord[''];
	chord['-'] = chord['min'] = chord['m'];
	chord['aug'] = chord['+'];
	chord['o'] = chord['º'] = chord['°'] = chord['dim'];
	chord['2'] = chord['sus2'];
	chord['4'] = chord['sus4'];
	
	chord['M7'] = chord['Maj7'] = chord['Δ7'] = chord['maj7'];
	chord['dom'] = chord['dom7'] = chord['7'];
	chord['aug7'] = chord['+7'];
	chord['min7'] = chord['-7'] = chord['m7'];
	chord['mMaj7'] = chord['mΔ7'] = chord['minΔ7'] = chord['minMaj7'] = chord['mM7'];
	chord['ø'] = chord['Ø'] = chord['m7b5'];
	chord['o7'] = chord['º7'] = chord['°7'] = chord['dim7'];
	
	var scale = {};
	
	// Heptatonic
	scale.major = ['1', '2', '3', '4', '5', '6', '7'];
	scale.minor = ['1', '2', 'm3', '4', '5', 'm6', 'm7'];
	scale.harmonic = ['1', '2', 'm3', '4', '5', 'm6', '7'];
	scale.melodic = ['1', '2', 'm3', '4', '5', '6', '7'];
	
	// Major modes
	scale.lydian = ['1', '2', '3', 'A4', '5', '6', '7'];
	// scale.ionian = scale.major
	scale.mixolydian = ['1', '2', '3', '4', '5', '6', 'm7'];
	scale.dorian = ['1', '2', 'm3', '4', '5', '6', 'm7'];
	// scale.aeolian = scale.minor
	scale.phrygian = ['1', 'm2', 'm3', '4', '5', 'm6', 'm7'];
	scale.locrian = ['1', 'm2', 'm3', '4', 'd5', 'm6', 'm7'];
	
	var _iteratorNormalCompletion3 = true;
	var _didIteratorError3 = false;
	var _iteratorError3 = undefined;
	
	try {
	  for (var _iterator3 = Object.keys(scale)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	    var _name = _step3.value;
	
	    scale[_name] = scale[_name].map(function (i) {
	      return interval[i];
	    });
	  }
	
	  // Pentatonic
	} catch (err) {
	  _didIteratorError3 = true;
	  _iteratorError3 = err;
	} finally {
	  try {
	    if (!_iteratorNormalCompletion3 && _iterator3.return) {
	      _iterator3.return();
	    }
	  } finally {
	    if (_didIteratorError3) {
	      throw _iteratorError3;
	    }
	  }
	}
	
	scale.pentatonic = {};
	scale.pentatonic.major = ['1', '2', '3', '5', '6'];
	scale.pentatonic.minor = ['1', 'm3', '4', '5', 'm7'];
	
	var _iteratorNormalCompletion4 = true;
	var _didIteratorError4 = false;
	var _iteratorError4 = undefined;
	
	try {
	  for (var _iterator4 = Object.keys(scale.pentatonic)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	    var _name2 = _step4.value;
	
	    scale.pentatonic[_name2] = scale.pentatonic[_name2].map(function (i) {
	      return interval[i];
	    });
	  }
	
	  // Aliases
	} catch (err) {
	  _didIteratorError4 = true;
	  _iteratorError4 = err;
	} finally {
	  try {
	    if (!_iteratorNormalCompletion4 && _iterator4.return) {
	      _iterator4.return();
	    }
	  } finally {
	    if (_didIteratorError4) {
	      throw _iteratorError4;
	    }
	  }
	}
	
	scale.ionian = scale.major;
	scale.aeolian = scale.minor;
	
	exports.interval = interval;
	exports.chord = chord;
	exports.scale = scale;
	function extend(fundamental, type) {
	  var semitones = Array.isArray(type) ? type : chordSemitones(type);
	
	  return semitones.map(function (d) {
	    return noteNameToSemitone[fundamental] + d;
	  });
	}

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mix = mix;
	exports.mixN = mixN;
	exports.panner = panner;
	/* Operators */
	
	function mix(s1, s2) {
	  var a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.5;
	
	  return s1 * a + s2 * (1 - a);
	}
	
	function mixN() {
	  var sum = 0;
	  for (var i = 0; i < arguments.length; i++) {
	    sum += arguments[i];
	  }
	  return sum / arguments.length;
	}
	
	function panner(signal, position) {
	  position = position / 2 + 0.5;
	
	  return [signal * (1 - position), signal * position];
	}

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.curry = curry;
	exports.choose = choose;
	exports.LimitRate = LimitRate;
	/* Utilities */
	
	function curry(uncurried) {
	  var args = Array.prototype.slice.call(arguments, 1);
	
	  return function () {
	    return uncurried.apply(this, args.concat(Array.prototype.slice.call(arguments, 0)));
	  };
	}
	
	function choose(array) {
	  return array[Math.floor(Math.random() * array.length)];
	}
	
	function LimitRate(f) {
	  var period = 1 / f;
	  var next_update = period;
	  var last_v = void 0;
	
	  return function (fn) {
	    var t = arguments[arguments.length - 1];
	
	    if (t > next_update) {
	      last_v = fn.apply(this, Array.from(arguments).slice(1));
	      next_update = next_update + period;
	    }
	
	    return last_v;
	  };
	}

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Util = exports.Music = exports.Operator = exports.Filter = exports.Envelope = exports.Generator = undefined;
	
	var _Music = __webpack_require__(32);
	
	Object.keys(_Music).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Music[key];
	    }
	  });
	});
	
	var _Generator = __webpack_require__(31);
	
	var Generator = _interopRequireWildcard(_Generator);
	
	var _Envelope = __webpack_require__(29);
	
	var Envelope = _interopRequireWildcard(_Envelope);
	
	var _Filter = __webpack_require__(7);
	
	var Filter = _interopRequireWildcard(_Filter);
	
	var _Operator = __webpack_require__(33);
	
	var Operator = _interopRequireWildcard(_Operator);
	
	var Music = _interopRequireWildcard(_Music);
	
	var _Util = __webpack_require__(34);
	
	var Util = _interopRequireWildcard(_Util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.Generator = Generator;
	exports.Envelope = Envelope;
	exports.Filter = Filter;
	exports.Operator = Operator;
	exports.Music = Music;
	exports.Util = Util;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.makeWAVURL = makeWAVURL;
	exports.quantizeInt16 = quantizeInt16;
	exports.Uint8Mono = Uint8Mono;
	exports.Uint8Stereo = Uint8Stereo;
	exports.Int16Mono = Int16Mono;
	exports.Int16Stereo = Int16Stereo;
	
	var _compile = __webpack_require__(4);
	
	/* PCM WAV generation */
	
	function makeWAVURL(data, numChannels, sampleRate) {
	  var littleEndian = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	  var bytesPerSample = data.BYTES_PER_ELEMENT;
	  var samplesPerChannel = data.length / numChannels;
	
	  var blockAlign = numChannels * bytesPerSample;
	  var byteRate = sampleRate * blockAlign;
	  var dataSize = samplesPerChannel * blockAlign;
	
	  var header = new ArrayBuffer(44); // Header length
	  var dv = new DataView(header);
	
	  var chunkID = littleEndian ? 0x52494646 // 'RIFF'
	  : 0x52494658; // 'RIFX'
	
	  dv.setUint32(0, chunkID, false); // ChunkID
	  dv.setUint32(4, dataSize + 36, true); // ChunkSize
	  dv.setUint32(8, 0x57415645, false); // Format ('WAVE')
	  dv.setUint32(12, 0x666d7420, false); // Subchunk1ID ('fmt ')
	  dv.setUint32(16, 16, true); // Subchunk1Size
	  dv.setUint16(20, 1, true); // AudioFormat (1 = PCM)
	  dv.setUint16(22, numChannels, true); // NumChannels
	  dv.setUint32(24, sampleRate, true); // SampleRate
	  dv.setUint32(28, byteRate, true); // ByteRate
	  dv.setUint16(32, blockAlign, true); // BlockAlign
	  dv.setUint16(34, bytesPerSample * 8, true); // BitsPerSample
	  dv.setUint32(36, 0x64617461, false); // Subchunk2ID ('data')
	  dv.setUint32(40, dataSize, true); // Subchunk2Size
	
	  var blob = new Blob([header, data], { type: 'audio/wav' });
	  return URL.createObjectURL(blob);
	}
	
	function quantizeUint8(v) {
	  return Math.floor((v + 1) / 2 * 0xff);
	}
	
	function quantizeInt16(v) {
	  return Math.floor((v + 1) / 2 * 0xffff - 0x8000);
	}
	
	function Uint8Mono(sampleRate, length, fn) {
	  var channelLength = Math.floor(length * sampleRate);
	  var buffer = new Uint8Array(channelLength);
	
	  for (var i = 0; i < buffer.length; i++) {
	    var t = i / sampleRate;
	    var y = void 0;
	    try {
	      y = fn(t);
	    } catch (e) {
	      return { error: (0, _compile.tryParseException)(e) };
	    }
	    buffer[i] = quantizeUint8(y);
	  }
	
	  return { buffer: buffer };
	}
	
	function Uint8Stereo(sampleRate, length, fn) {
	  var channelLength = Math.floor(length * sampleRate);
	  var buffer = new Uint8Array(2 * channelLength);
	
	  for (var i = 0; i < channelLength; i++) {
	    var t = i / sampleRate;
	    var l = void 0,
	        r = void 0;
	    try {
	      var _fn = fn(t);
	
	      var _fn2 = _slicedToArray(_fn, 2);
	
	      l = _fn2[0];
	      r = _fn2[1];
	    } catch (e) {
	      return { error: (0, _compile.tryParseException)(e) };
	    }
	    buffer[i * 2] = quantizeUint8(l);
	    buffer[i * 2 + 1] = quantizeUint8(r);
	  }
	
	  return { buffer: buffer };
	}
	
	function Int16Mono(sampleRate, length, fn) {
	  var channelLength = Math.floor(length * sampleRate);
	  var buffer = new Int16Array(channelLength);
	
	  for (var i = 0; i < channelLength; i++) {
	    var t = i / sampleRate;
	    var y = void 0;
	    try {
	      y = fn(t);
	    } catch (e) {
	      return { error: (0, _compile.tryParseException)(e) };
	    }
	    buffer[i] = quantizeInt16(y);
	  }
	
	  return { buffer: buffer };
	}
	
	function Int16Stereo(sampleRate, length, fn) {
	  var channelLength = Math.floor(length * sampleRate);
	  var buffer = new Int16Array(2 * channelLength);
	
	  for (var i = 0; i < channelLength; i++) {
	    var t = i / sampleRate;
	    var l = void 0,
	        r = void 0;
	    try {
	      var _fn3 = fn(t);
	
	      var _fn4 = _slicedToArray(_fn3, 2);
	
	      l = _fn4[0];
	      r = _fn4[1];
	    } catch (e) {
	      return { error: (0, _compile.tryParseException)(e) };
	    }
	    buffer[i * 2] = quantizeInt16(l);
	    buffer[i * 2 + 1] = quantizeInt16(r);
	  }
	
	  return { buffer: buffer };
	}

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _compile = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ScriptProcessorPlayer = function () {
	  function ScriptProcessorPlayer(audioCtx, bufferLength, fn, length) {
	    var playing = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	    var lastFrame = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	    _classCallCheck(this, ScriptProcessorPlayer);
	
	    this.audioCtx = audioCtx;
	    this.bufferLength = bufferLength;
	
	    this.fn = fn;
	    this.length = length;
	    this.lastFrame = lastFrame;
	
	    if (playing) {
	      this.initScriptProcessor();
	    }
	  }
	
	  /* PUBLIC API */
	
	  _createClass(ScriptProcessorPlayer, [{
	    key: 'play',
	    value: function play() {
	      var _this = this;
	
	      if (typeof this.scriptProcessor === 'undefined' && typeof this.fn !== 'undefined') {
	        this.audioCtx.resume().then(function () {
	          _this.initScriptProcessor();
	
	          var onPlayingChange = _this.onPlayingChange;
	
	          if (typeof onPlayingChange !== 'undefined') onPlayingChange(true);
	        });
	      }
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      if (typeof this.scriptProcessor !== 'undefined') {
	        this.destroyScriptProcessor();
	
	        var onPlayingChange = this.onPlayingChange;
	
	        if (typeof onPlayingChange !== 'undefined') onPlayingChange(false);
	      }
	    }
	  }, {
	    key: 'togglePlay',
	    value: function togglePlay() {
	      if (typeof this.scriptProcessor !== 'undefined') {
	        this.pause();
	      } else {
	        this.play();
	      }
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      this.pause();
	      this.lastFrame = 0;
	
	      var onFrame = this.onFrame;
	
	      if (typeof onFrame !== 'undefined') onFrame(0);
	    }
	  }, {
	    key: 'setFrame',
	    value: function setFrame(frame) {
	      this.lastFrame = frame;
	    }
	  }, {
	    key: 'setFunction',
	    value: function setFunction(fn) {
	      this.fn = fn;
	    }
	  }, {
	    key: 'setLength',
	    value: function setLength(length) {
	      this.length = length;
	    }
	
	    /* PRIVATE FUNCTIONS */
	
	  }, {
	    key: 'initScriptProcessor',
	    value: function initScriptProcessor() {
	      var audioCtx = this.audioCtx,
	          bufferLength = this.bufferLength;
	
	
	      if (typeof this.scriptProcessor !== 'undefined') {
	        this.destroyScriptProcessor();
	      }
	
	      this.scriptProcessor = audioCtx.createScriptProcessor(bufferLength, 0, 2);
	      this.scriptProcessor.onaudioprocess = this.handleAudioProcess.bind(this);
	      this.scriptProcessor.connect(audioCtx.destination);
	    }
	  }, {
	    key: 'destroyScriptProcessor',
	    value: function destroyScriptProcessor() {
	      if (typeof this.scriptProcessor !== 'undefined') {
	        this.scriptProcessor.disconnect(this.audioCtx.destination);
	        this.scriptProcessor = undefined;
	      }
	    }
	  }, {
	    key: 'handleAudioProcess',
	    value: function handleAudioProcess(audioProcessingEvent) {
	      var sampleRate = this.audioCtx.sampleRate,
	          lastFrame = this.lastFrame,
	          fn = this.fn,
	          length = this.length,
	          onFrame = this.onFrame,
	          onRenderTime = this.onRenderTime,
	          onError = this.onError;
	
	
	      var buffer = audioProcessingEvent.outputBuffer;
	      var lChannel = buffer.getChannelData(0);
	      var rChannel = buffer.getChannelData(1);
	
	      // Fill the buffer and time how long it takes
	      var start = void 0;
	      if (typeof onRenderTime !== 'undefined') {
	        start = performance.now();
	      }
	      for (var i = 0; i < buffer.length; i++) {
	        var t = (i + lastFrame) / sampleRate;
	        try {
	          var _fn = fn(t),
	              _fn2 = _slicedToArray(_fn, 2),
	              l = _fn2[0],
	              r = _fn2[1];
	
	          lChannel[i] = l;
	          rChannel[i] = r;
	        } catch (e) {
	          if (typeof onError !== 'undefined') {
	            onError((0, _compile.tryParseException)(e));
	          }
	          // Try to recover using backup fn
	          if (this.lastFn) {
	            fn = this.fn = this.lastFn;
	            this.lastFn = undefined;
	            i = 0;
	            continue;
	          }
	          // No backup fn, just stop
	          else {
	              this.pause();
	              return;
	            }
	        }
	      }
	
	      // Advance frame
	      lastFrame += buffer.length;
	      if (typeof onFrame !== 'undefined') onFrame(lastFrame);
	
	      // Save this (presumably working) fn as a backup fn
	      if (typeof this.lastFn === 'undefined') this.lastFn = fn;
	
	      // Continue playing or stop if we've reached the end
	      if (length && lastFrame > length * sampleRate) {
	        this.stop();
	      } else {
	        this.lastFrame = lastFrame;
	        if (typeof onRenderTime !== 'undefined') {
	          onRenderTime(performance.now() - start);
	        }
	      }
	    }
	  }]);
	
	  return ScriptProcessorPlayer;
	}();
	
	exports.default = ScriptProcessorPlayer;

/***/ }),
/* 38 */,
/* 39 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, exports) {

	module.exports = "const { Generator, Envelope, Filter, Operator, Music, Util } = Musika\n\nconst CHORD_LENGTH = 3\nconst CHORDS = [\n  ['A2',  [0, 3, 7]],\n  ['A2',  [0, 3, 7]],\n  ['A2',  [0, 3, 8]],\n  ['A2',  [0, 3, 8]],\n  ['A2',  [0, 3, 7]],\n  ['A2',  [0, 3, 8]],\n  ['A2',  [0, 3, 8]],\n  ['D2',  [0, 3, 8]],\n  ['Bb2', [7, 4, 0]],\n  ['Bb2', [7, 4, 0]],\n  ['Bb2', [9, 4, 0]],\n  ['F2',  [7, 2, 0]],\n  ['F2',  [7, 2, 0]],\n].map(([n, s]) => Music.extend(n, s))\n\nconst Note = A => {\n  const OSC = Generator.Saw()\n  return (f, t) => OSC(f, t) * Note.RELEASE(t % Note.LENGTH) * A\n}\nNote.LENGTH = 0.1\nNote.RELEASE = Util.curry(Envelope.release, 0.08, Note.LENGTH, 1.2)\n\nconst Detune = (A, F) => {\n  const OSC = Generator.Saw()\n  return t => OSC(F, t) * A\n}\n\n/* SONG */\n\nconst detune = Detune(0.1, 0.4)\nconst losc = Note(0.05)\nconst rosc = Note(0.05)\n\nreturn t => {\n  const note_in_song = Math.floor(t / Note.LENGTH)\n  const chord_i = Math.floor(note_in_song / CHORD_LENGTH) % CHORDS.length\n  const note_i = note_in_song % CHORD_LENGTH\n  const f = Music.semitoneToFrequency(CHORDS[chord_i][note_i])\n\n  return [\n    losc(f, t),\n    rosc(f + detune(t), t)\n  ]\n}\n"

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	module.exports = "const { Generator } = Musika\n\nconst F = 79            // Base frequency\nconst DF = 4            // Beat frequency\nconst A = Math.SQRT1_2  // Amplitude\n\nconst oscL = Generator.Sin()\nconst oscR = Generator.Sin()\n\nreturn t => [\n  oscL(F, t) * A,\n  oscR(F + DF, t) * A,\n]\n"

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	module.exports = "const { Generator, Envelope, Filter, Operator, Music, Util } = Musika\n\nreturn t => {\n  // Start writing your Musika here!\n\n  return [0, 0]\n}\n"

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	module.exports = "const { Generator, Filter, Envelope, Music, Util } = Musika\n\nconst TEMPO = Music.Tempo(2, 4, 90)\nconst A = 7\nconst Q = 15\nconst PASSES = 3\nconst NOTES = [\n  ['A4', 'C5'],\n  ['A4', 'C5'],\n  ['A4', 'C5'],\n  ['A4', 'C5', 'E5'],\n  ['A4', 'C5'],\n  ['A4', 'C5'],\n  ['A4', 'C5'],\n  ['A4', 'C5', 'E#5', 'A4', 'C5', 'E#5'],\n  ['A4', 'C5'],\n  ['A4', 'C5'],\n  ['A4', 'C5'],\n  ['E#5', 'C5', 'A4', 'E#5', 'C5', 'A4',],\n  ['C5', 'A4'],\n  ['C5', 'A4'],\n  ['C5', 'A4'],\n  ['E5', 'C5', 'A4', 'E5', 'C5', 'Ab4'],\n].map(bar => bar.map(n => Music.noteNameToFrequency[n]))\n\nconst NoiseGen = () => {\n  const filterUnits = Array(PASSES).fill().map(() => Filter.Biquad())\n\n  return f => {\n    const c = Filter.Biquad.BP(f/sampleRate, Q)\n    return filterUnits.reduce(\n      (v, filter) => filter(c, v),\n      Generator.random() * A\n    )\n  }\n}\n\nconst noiseL = NoiseGen(), noiseR = NoiseGen()\nconst limiter = Util.LimitRate(2)\n\nreturn t => {\n  const barIndex = Math.floor(t / TEMPO.barLength)\n  const bar = NOTES[barIndex % NOTES.length]\n  const noteLength = TEMPO.barLength / bar.length\n  const noteIndex = Math.floor(TEMPO.timeInBar(t) / noteLength)\n  const f = bar[noteIndex % bar.length]\n  const a = Envelope.attack(TEMPO.noteLength(32), 2, t % noteLength)\n    * Envelope.release(TEMPO.noteLength(32), noteLength, 2, t % noteLength)\n\n  return [\n    noiseL(f) * a,\n    noiseR(f) * a,\n  ]\n}\n"

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	module.exports = "const { Generator, Filter } = Musika\n\nconst NoiseGen = () => {\n  const A = Math.SQRT1_2  // Amplitude = 0.707\n  const COEFF = Filter.Biquad.LP(400/sampleRate, Math.SQRT1_2)  // Cutoff = 400Hz, Q = 0.707\n\n  const filter = Filter.Biquad()\n  return () => filter(COEFF, Generator.random() * A)\n}\n\nconst noiseL = NoiseGen(), noiseR = NoiseGen()\n\nreturn () => [\n  noiseL(),\n  noiseR(),\n]\n"

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	module.exports = "const { Generator, Envelope, Filter, Operator, Music, Util } = Musika\n\nconst triggerSweep = Generator.Sin()\n\nlet from = 0, length = 0, pan = 0.5\n\nreturn t => {\n  let out = 0\n\n  const dt = Math.random() * (triggerSweep(0.1, t) + 1.0) / 2 * 0.1\n\n  const to = from + length\n\n  if (t < from || t > to) {\n    from = t + dt\n    length = Math.random() * 0.1\n    pan = 0.25 + Math.random() * 0.5\n  } else if (t > from) {\n    out = Math.random() * 0.5\n  }\n\n  out *= Envelope.attack(length, 2, t)\n       * Envelope.release(length, to, 2.9, t)\n\n  return [\n    out * (1 - pan),\n    out * pan,\n  ]\n}\n"

/***/ }),
/* 48 */
/***/ (function(module, exports) {

	module.exports = "const { Generator, Filter } = Musika\n\nconst NoiseGen = () => {\n  const A = Math.SQRT1_2  // Amplitude = 0.707\n\n  const filter = Filter.Biquad()\n  return cutoff => {\n    const coeff = Filter.Biquad.LP(cutoff/sampleRate, Math.SQRT1_2)\n    return filter(coeff, Generator.random() * A)\n  }\n}\n\nconst noiseL = NoiseGen(), noiseR = NoiseGen()\nconst cutL = Generator.Sin(), cutR = Generator.Sin()\n\nreturn t => [\n  noiseL(300 + cutL(0.1, t) * 200),\n  noiseR(300 + cutR(0.08, t) * 200),\n]\n"

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	module.exports = "const { Generator, Envelope, Filter, Operator, Music, Util } = Musika\n\nconst LENGTH = 15\nconst NUM_VOICES = 20\nconst BASE_SEMITONE = 14.5 + Music.LOWEST_SEMITONE_DIFF_FROM_BASE\nconst ATTACK_LENGTH = 3\nconst ATTACK_STRENGTH = 2\nconst RELEASE_LENGTH = 3\nconst RELEASE_STRENGTH = 2\n\nsetLength(LENGTH)\n\nconst Voice = () => ({\n  osc: Generator.Saw(),\n  f: 200 + Math.random() * 200,\n  f_noise: Generator.LFNoise1(0.5),\n  target_f_noise: Generator.LFNoise1(0.1),\n  pan: (Math.random() + 0.5) / 2,\n  x1: 5.5 + Math.random() * 0.5,\n  x2: 8.5 + Math.random() * 0.5,\n  y1: 0.1 + Math.random() * 0.1,\n})\n\nconst voices = Array(NUM_VOICES).fill()\n  .map(() => Voice())\n  .sort(({ f }) => f)\n  .map((voice, i) => {\n    const semitone = Math.floor(i / (NUM_VOICES/6)) * 12 + BASE_SEMITONE\n    return {\n      ...voice,\n      i,\n      target_f: Music.semitoneToFrequency(semitone),\n    }\n  })\n\n// Faster than using Envelope.linear\nconst sweep_envelope = (x1, x2, y1, t) =>\n  t < x1\n    ? y1 * t/x1\n  : t < x2\n    ? y1 + (t - x1) * (1 - y1) / (x2 - x1)\n  : 1\n\nreturn t => {\n  let lout = 0\n  let rout = 0\n\n  for (const voice of voices) {\n    const { i, osc, f, f_noise, target_f, target_f_noise, pan, x1, x2, y1 } = voice\n\n    const s = sweep_envelope(x1, x2, y1, t)\n\n    const new_f = f + f_noise(t) * 3 * (i + 1)\n    const new_target_f = target_f + target_f_noise(t) * i/4\n    const v = osc(Operator.mix(new_target_f, new_f, s), t)\n\n    lout += v * (1 - pan)\n    rout += v * pan\n  }\n\n  const amp = Envelope.attack(ATTACK_LENGTH, ATTACK_STRENGTH, t)\n    * Envelope.release(RELEASE_LENGTH, LENGTH, RELEASE_STRENGTH, t)\n    / NUM_VOICES\n\n  return [\n    lout * amp,\n    rout * amp,\n  ]\n}\n"

/***/ })
]);


// WEBPACK FOOTER //
// lambda-musika.013c8a92af50c3bf84cc.js